module.exports = __webpack_public_path__ + "img/E20W.6bb8247e.jpeg";